import {create} from "zustand";
import { persist } from "zustand/middleware";


export const useCourse = create(
  persist(
    (set, get) => ({
      courseDocs: null,
      courseDoc: null,
      courseAction:{
        courseId:"",
        action:""
      },
      _hasHydrated: false,
      setCourseAction: (courseAction) => {
        return set({ courseAction });
      },
      setCourse: (courseDoc) => {
        return set({ courseDoc });
      },
      setCourses: (courseDocs) => {
        return set({ courseDocs });
      },
      getCourses: () => {
        return get().courseDocs;
      },
      setHasHydrated: (value) => set({ _hasHydrated: value }),
    }),
    {
      name: "course-storage",
      getStorage: () => localStorage,
      partialize: (state) => ({
        _hasHydrated: state._hasHydrated,
      }),
      onRehydrateStorage: () => (state) => {
        state?.setHasHydrated(true);
      },
    }
  )
);
